import { RouteComponentProps } from "@reach/router";

export const BoardsGroup: React.FC<RouteComponentProps> = ({ children }) => {
  return <>{children}</>;
};
